import { Radio } from 'antd';
import dayjs from 'dayjs';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { switchLanguage } from '@/app/features/customise/customiseSlice';
import enLang from '@/assets/images/languages/en.svg';
import ruLang from '@/assets/images/languages/ru.svg';
import 'dayjs/locale/en';
import 'dayjs/locale/ru';
import styles from './HeaderLanguages.module.css';

const HeaderLanguages: React.FC = () => {
  const dispatch = useDispatch();
  const customise = useSelector((state: any) => state.customise);
  const [activeLanguage, setActiveLanguage] = useState(customise.language);

  useEffect(() => {
    setActiveLanguage(customise.language);
  }, [customise]);

  const handleLanguageSwitch = (lang: string) => {
    if (lang !== activeLanguage) {
      dayjs.locale(lang);
      dispatch(switchLanguage(lang));
    }
  };

  return (
    <Radio.Group value={activeLanguage} onChange={(event) => handleLanguageSwitch(event.target.value)}>
      <Radio.Button value="ru" className={styles.hpLanguageRadio}>
        <img src={ruLang} alt="Russian" className={styles.hpLanguageFlag} />
        Ru
      </Radio.Button>
      <Radio.Button value="en" className={styles.hpLanguageRadio}>
        <img src={enLang} alt="English" className={styles.hpLanguageFlag} />
        En
      </Radio.Button>
    </Radio.Group>
  );
};

export default HeaderLanguages;
